import { IconProps } from "../../utils/global-types/global-types";

const ExclamatoryMarkErrorIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 13"
      className={className ? className : "w-[12px] h-[13px]"}
      {...rest}
    >
      <g clipPath="url(#clip0_12574_146016)">
        <path
          fill="currentColor"
          d="M6 2.125C5.13471 2.125 4.28885 2.38159 3.56938 2.86232C2.84992 3.34305 2.28916 4.02633 1.95803 4.82576C1.6269 5.62519 1.54026 6.50485 1.70907 7.35352C1.87788 8.20219 2.29456 8.98174 2.90641 9.59359C3.51826 10.2054 4.29781 10.6221 5.14648 10.7909C5.99515 10.9597 6.87482 10.8731 7.67424 10.542C8.47367 10.2108 9.15695 9.65009 9.63768 8.93062C10.1184 8.21116 10.375 7.36529 10.375 6.5C10.3746 5.3398 9.91356 4.22722 9.09317 3.40683C8.27278 2.58645 7.16021 2.12539 6 2.125ZM6 9.125C5.88463 9.125 5.77185 9.09079 5.67592 9.02669C5.57999 8.96259 5.50522 8.87149 5.46107 8.7649C5.41692 8.65831 5.40537 8.54102 5.42788 8.42786C5.45039 8.31471 5.50594 8.21077 5.58752 8.12919C5.6691 8.04761 5.77304 7.99205 5.8862 7.96954C5.99935 7.94703 6.11664 7.95859 6.22323 8.00274C6.32982 8.04689 6.42093 8.12166 6.48503 8.21758C6.54912 8.31351 6.58334 8.42629 6.58334 8.54167C6.58287 8.69623 6.52127 8.84434 6.41197 8.95364C6.30268 9.06293 6.15457 9.12454 6 9.125ZM6.66792 4.60125L6.4725 6.94042C6.46231 7.05871 6.40812 7.16888 6.32063 7.24915C6.23315 7.32943 6.11873 7.37396 6 7.37396C5.88127 7.37396 5.76686 7.32943 5.67937 7.24915C5.59188 7.16888 5.53769 7.05871 5.5275 6.94042L5.33209 4.60125C5.32366 4.51065 5.33375 4.41927 5.36175 4.33269C5.38975 4.24611 5.43508 4.16613 5.49497 4.09762C5.55485 4.02911 5.62805 3.9735 5.71011 3.93417C5.79217 3.89485 5.88137 3.87263 5.97229 3.86886C6.06321 3.8651 6.15394 3.87987 6.23897 3.91228C6.324 3.94469 6.40154 3.99406 6.46689 4.05739C6.53223 4.12072 6.58401 4.19668 6.61907 4.28065C6.65413 4.36462 6.67175 4.45484 6.67084 4.54583C6.67132 4.56435 6.67034 4.58288 6.66792 4.60125Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_12574_146016">
          <rect
            width="9.33333"
            height="9.33333"
            fill="white"
            transform="translate(1.33594 1.83398)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ExclamatoryMarkErrorIcon;
